import { baseUrl } from "../dataProvider";

export const supportRequestStatuses = {
  open: 'Open',
  closed: 'Closed',
};

export const formStatuses = {
  draft: 'Draft',
  // beta: 'Beta',
  published: 'Published',
  archived: 'Archived',
};

export const formEntryStatuses = {
  draft: 'In Progress',
  'in-review': 'In Review',
  'needs-attention': 'Needs Attention',
  accepted: 'Accepted',
};

export function getStatuses(status = null) {
  if(!status) {
    return formEntryStatuses;
  }

  return formEntryStatuses[status] ?? status;
}

export const designations = {
  accredited: 'Accredited',
  affiliate: 'Affiliate',
  none: 'N/A',
};

export function getDesignations(designation = null) {
  return designations[designation] ?? designation;
}

export function toSelectChoices(input) {
  let choices = [];
  if(Array.isArray(input)) {
    //
  } else {
    for(const key in input) {
      choices.push({id: key, name: input[key]});
    }
    //
  }

  // id, name

  return choices;
}

export const states = {
  AZ: 'Arizona',
  AL: 'Alabama',
  AK: 'Alaska',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DC: 'District of Columbia',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
  AS: 'American Samoa',
  GU: 'Guam',
  MP: 'Northern Mariana Islands',
  PR: 'Puerto Rico',
  VI: 'U.S. Virgin Islands',
  UM: 'U.S. Minor Outlying Islands',
};

export function stateAbbrToName(acronym) {
    return states[acronym] ?? acronym;
};

export function locationString(obj) {
  let toJoin = [];
  if(typeof obj.city === 'string' && obj.city.trim().length) {
    toJoin.push(obj.city);
  }
  if(typeof obj.state === 'string' && obj.state.trim().length) {
    toJoin.push(obj.state);
  }

  return toJoin.join(', ');
};

export function objectToSelectChoices(obj) {

  return Object.entries(obj).map(entry => ({id: entry[0], name: entry[1]}));

  /*
  let objArray = [];
  Object.keys(obj).forEach(key => objArray.push({
    id: key,
    name: obj[key],
  }));
  return objArray;
  */

}

export function getFriendlySettingName(name) {
  if(name === 'active_form') return 'Active Accreditation Form';
  if(name === 'login_help') return 'Login Help Text';
  // if(name === 'fuel_links') return ''

  // https://stackoverflow.com/a/64489760
  return name.replace (/^[-_]*(.)/, (_, c) => c.toUpperCase()).replace (/[-_]+(.)/g, (_, c) => ' ' + c.toUpperCase());
}

export function getSettingDescription(name) {
  if(name === 'active_form') {
    return <>
      <p>
        Dashboard widgets, accreditation deadlines, etc. are based on this setting.
        <br/>
        Users cannot fill out an accreditation form unless this is set.
      </p>
      <p style={{fontWeight: 'bold'}}>Make sure you set this after all coordinating programs have set up their forms.</p>
    </>
  }

  return null;
}

// https://stackoverflow.com/a/52799327
export function hasJsonStructure(str) {
  if (typeof str !== 'string') return false;
  try {
      const result = JSON.parse(str);
      const type = Object.prototype.toString.call(result);
      return type === '[object Object]'
          || type === '[object Array]';
  } catch (err) {
      return false;
  }
}

export const round = (input) => {
  return Math.round(input * 100) / 100;
}

export const maybeCorrectRichTextValue = (input) => {
  if(input.match('<') || input.match('/>')) {
    return input;
  }

  let newInput = [];

  let split = input.split("\n");
  let isInList = false;
  for(let line of split) {
    // NOTE: All of this code works, BUT TipTap doesn't support list-style-type
    // So until it does, we're just going to trim & push
    /*
    line = line.trim();
    // convert string lists to ordered/unordered
    if(line.match(/^[a-z0-9]+\. /)) {
      if(!isInList) {
        isInList = true;
        // handle a-z vs 0-9
        if(line.match(/^[a-z]/)) {
          newInput.push('<ol style="list-style-type: lower-alpha">');
        } else {
          newInput.push('<ol>');
        }
      }

      newInput.push(`<li>${line.replace(/^[a-z0-9]+\. /, '')}</li>`);

    } else {
      if(isInList) {
        newInput.push('</ol>');
        isInList = false;
      }

      newInput.push(`<p>${line}</p>`);
    }
    */

    // Note: disable this when enabling the list generation code above
    line = line.trim();
    newInput.push(`${line}`);
  }

  // Note: disable this when enabling the list generation code above
  return `<p>${newInput.join("<br/>")}</p>`;

  // Note: enable this when enabling the list generation code above
  //return newInput.join("\n");

  return input;
}

// https://stackoverflow.com/a/20732091
export function humanFileSize(size) {
  var i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
  return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
}

export function frontendFormUrl(formUuid, communityId) {
  return `${baseUrl}/forms/${formUuid}?community=${communityId}`;
};

export function generateRandomString(len = 6) {
  // https://stackoverflow.com/a/19964557
  return (Math.random().toString(16)+'00000000000000000').slice(2, len+2);
}

export function sortBySequence(a, b) {
  return a.sequence - b.sequence;
}

export function capitalizeFirst(word) {
  return word.charAt(0).toUpperCase()
  + word.slice(1);
};
